'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiAttachment = function TiAttachment(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.6 11.1c-2.6-2.6-6.8-2.6-9.4 0l-7.6 7.5c-0.8 0.8-1.2 1.8-1.2 3 0 1.1 0.4 2.1 1.2 2.9 0.8 0.8 1.9 1.2 3 1.2 1 0 2.1-0.4 2.9-1.2l3.5-3.5c0.7-0.7 1-1.5 1-2.4 0-0.8-0.3-1.7-1-2.3l-5.8 5.9c-0.4 0.3-0.9 0.3-1.2 0-0.2-0.3-0.3-0.5-0.3-0.6 0-0.2 0.1-0.4 0.3-0.6l7.5-7.6c1.3-1.3 3.4-1.3 4.8 0 1.2 1.3 1.2 3.4 0 4.7l-11.8 11.8c-1.3 1.3-3.5 1.3-4.7 0-1.4-1.3-1.4-3.4 0-4.7l0.1-0.2c-0.7-1-1.2-2.2-1.2-3.5l-1.3 1.3c-2.6 2.6-2.6 6.9 0 9.5 1.3 1.3 3 1.9 4.7 1.9s3.4-0.6 4.7-1.9l11.8-11.8c2.6-2.6 2.6-6.8 0-9.4z' })
        )
    );
};

exports.default = TiAttachment;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/attachment.js
// module id = 2999
// module chunks = 0